import axios from 'axios';
import {
  GET_ASSIGNED_QUESTIONS_TO_ASSESSMENT_URL,
  GET_CHECKLIST_WEIGHTS_URL,
  GET_SUBMITTED_RISK_ASSESSMENT_ANSWERS_URL,
  LIST_RISK_FRAMEWORKS_BY_PROJECT_URL,
  SUBMIT_RISK_ASSESSMENT_ANSWERS_URL,
  get_request_config,
} from '@/utils/system_constants/constant.js';

function parse_json_string(value, fallback = {}) {
  try { return JSON.parse(value); }
  catch { return fallback; }
}

function response_payload(response) {
  return response?.data ?? response ?? {};
}

function parse_nested_data(value) {
  return typeof value === 'string' ? parse_json_string(value) : value;
}

function parse_response_data(response) {
  const raw_data = response_payload(response);
  if (typeof raw_data !== 'string') return raw_data;
  return parse_nested_data(parse_json_string(raw_data));
}

function fetch_risk_frameworks_request(config) {
  return axios.get(LIST_RISK_FRAMEWORKS_BY_PROJECT_URL, config);
}

function fetch_assigned_questions_request(config) {
  return axios.get(GET_ASSIGNED_QUESTIONS_TO_ASSESSMENT_URL, config);
}

function fetch_checklist_weights_request(config) {
  return axios.get(GET_CHECKLIST_WEIGHTS_URL, config);
}

function fetch_submitted_answers_request(config) {
  return axios.get(GET_SUBMITTED_RISK_ASSESSMENT_ANSWERS_URL, config);
}

function submit_risk_assessment_request(data, config) {
  return axios.post(SUBMIT_RISK_ASSESSMENT_ANSWERS_URL, data, config);
}

export const fetch_risk_frameworks_by_project = async (project_id) => {
  const response = await fetch_risk_frameworks_request(
    get_request_config({ params: { project_id } })
  );
  return parse_response_data(response);
};

export const fetch_assigned_questions_to_assessment = async (assessment_id) => {
  const response = await fetch_assigned_questions_request(
    get_request_config({ params: { assessment_id } })
  );
  return parse_response_data(response);
};

export const fetch_checklist_weights = async (assessment_id) => {
  const response = await fetch_checklist_weights_request(
    get_request_config({ params: { assessment_id } })
  );
  return parse_response_data(response);
};

export const fetch_submitted_risk_assessment_answers = async ({
  entity_id,
  assessment_id,
} = {}) => {
  const response = await fetch_submitted_answers_request(
    get_request_config({ params: { entity_id, assessment_id } })
  );
  return parse_response_data(response);
};

export const submit_risk_assessment_answers = async ({
  entity_id,
  assessment_id,
  answers = {},
} = {}) => {
  const response = await submit_risk_assessment_request(
    { entity_id, assessment_id, answers },
    get_request_config()
  );
  return parse_response_data(response);
};
